(function () {
  'use strict';

  if (window.__gkConfiguratorCartBridgeInstalled) return;
  window.__gkConfiguratorCartBridgeInstalled = true;

  var SOURCES = { 'grillking-bbq': '/bbq', 'grillking-pergola': '/' };
  var READY_TYPE = 'cart-bridge-ready';
  var PROBE_TYPE = 'cart-bridge-probe';
  var REQUEST_TYPE = 'cart-add-request';
  var RESULT_TYPE = 'cart-add-result';
  var CONTACT_REQUEST_TYPE = 'contact-request';
  var CONTACT_RESULT_TYPE = 'contact-result';
  var MAX_ITEMS = 50;
  var MAX_QUANTITY = 20;
  var ALLOWED_PROPERTY_KEYS = ['Ref', 'Configuration', 'Layout', 'Size', 'Gas', 'Cabinet', 'Finish', 'Component', 'Share', 'Module', 'Preview', 'Project', 'Project Type', 'Bundle'];
  var MAX_CONTACT_BODY = 12000;
  var QUOTE_INBOX = 'michael@grillkingbbqs.au';
  var QUOTE_INBOX_CC = 'alan@grillkingbbqs.au';
  // Production app origin plus local studio origins for `shopify theme dev`.
  // Local entries only matter when a dev store serves this theme locally;
  // a published storefront never embeds a localhost iframe, and senders are
  // additionally pinned to a known studio frame (see isKnownStudioFrame).
  var ALLOWED_APP_ORIGINS = [
    'https://grillkingbbqs-and-pergola.vercel.app',
    'http://127.0.0.1:5174',
    'http://localhost:5174'
  ];

  function studioPathname(urlString) {
    try {
      return new URL(urlString, window.location.href).pathname.replace(/\/+$/, '') || '/';
    } catch (error) {
      return '';
    }
  }

  var completed = new Map();
  var pending = new Map();
  var COMPLETED_TTL_MS = 10 * 60 * 1000;
  var PENDING_TIMEOUT_MS = 20000;
  var CONTACT_PENDING_TIMEOUT_MS = 120000;
  var contactSubmitQueue = Promise.resolve();

  function normalizeOrigin(value) {
    try {
      return new URL(value).origin;
    } catch (error) {
      return '';
    }
  }

  function isAllowedOrigin(origin) {
    return ALLOWED_APP_ORIGINS.indexOf(normalizeOrigin(origin)) !== -1;
  }

  function isKnownStudioFrame(source, origin) {
    var frames = document.querySelectorAll('iframe[data-egj-iframe]');
    for (var index = 0; index < frames.length; index += 1) {
      var frame = frames[index];
      if (frame.contentWindow !== source) continue;

      var configuredUrl = frame.getAttribute('data-src') || frame.getAttribute('src') || '';
      if (normalizeOrigin(configuredUrl) === normalizeOrigin(origin)) return true;
    }
    return false;
  }


  function postReadyToFrame(frame) {
    if (!frame || !frame.contentWindow) return;

    // The iframe is lazy-loaded and initially has no src. about:blank inherits
    // the Shopify parent's origin, so posting to the future Vercel origin at
    // that point only creates a target-origin warning. Announce readiness only
    // after the frame has actually navigated to an allowed app origin.
    var actualUrl = frame.getAttribute('src') || '';
    if (!actualUrl) return;
    var targetOrigin = normalizeOrigin(actualUrl);
    if (!isAllowedOrigin(targetOrigin)) return;
    // Pathname only — deep-link query strings (?range=&step=) must not break source routing.
    var path = studioPathname(actualUrl);
    var source = Object.keys(SOURCES).find(function (key) { return SOURCES[key] === path; });
    if (!source) return;
    frame.contentWindow.postMessage({ source: source, type: READY_TYPE, version: 1 }, targetOrigin);
  }

  function announceReady() {
    var frames = document.querySelectorAll('iframe[data-egj-iframe]');
    for (var index = 0; index < frames.length; index += 1) {
      var frame = frames[index];
      if (frame.dataset.egjBbqBridgeBound !== 'true') {
        frame.dataset.egjBbqBridgeBound = 'true';
        frame.addEventListener('load', function (event) {
          postReadyToFrame(event.currentTarget);
          window.setTimeout(function () { postReadyToFrame(event.currentTarget); }, 250);
        });
      }
      // Do not post readiness synchronously here. The iframe can have its
      // `src` attribute set while navigation is still on the inherited
      // about:blank origin. The load handler above and the configurator's
      // explicit probe both provide reliable readiness without that race.
    }
  }

  function sanitizeStudioPayload(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
    var result = {};
    var keys = Object.keys(value);
    for (var index = 0; index < keys.length && index < 20; index += 1) {
      var key = keys[index];
      if (!/^[a-zA-Z][a-zA-Z0-9]{0,40}$/.test(key)) continue;
      var entry = value[key];
      if (typeof entry === 'string') {
        var clipped = entry.replace(/[\r\n\0]/g, ' ').trim().slice(0, 180);
        if (!clipped || clipped.indexOf('@') !== -1) continue;
        result[key] = clipped;
      } else if (typeof entry === 'number' && isFinite(entry)) {
        result[key] = entry;
      } else if (typeof entry === 'boolean') {
        result[key] = entry;
      }
    }
    return result;
  }

  function postStudioToFrames(type, payload) {
    var frames = document.querySelectorAll('iframe[data-egj-iframe]');
    for (var index = 0; index < frames.length; index += 1) {
      var frame = frames[index];
      if (!frame.contentWindow) continue;
      var actualUrl = frame.getAttribute('src') || '';
      var targetOrigin = normalizeOrigin(actualUrl);
      if (!isAllowedOrigin(targetOrigin)) continue;
      var path = studioPathname(actualUrl);
      var source = Object.keys(SOURCES).find(function (key) { return SOURCES[key] === path; });
      if (!source || !isKnownStudioFrame(frame.contentWindow, targetOrigin)) continue;
      frame.contentWindow.postMessage({
        source: source,
        version: 1,
        type: type,
        timestamp: Date.now(),
        payload: payload
      }, targetOrigin);
    }
  }

  function safeProperties(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;

    var result = {};
    for (var index = 0; index < ALLOWED_PROPERTY_KEYS.length; index += 1) {
      var key = ALLOWED_PROPERTY_KEYS[index];
      if (!Object.prototype.hasOwnProperty.call(value, key)) continue;
      if (typeof value[key] !== 'string') return null;
      result[key] = value[key].slice(0, 250);
    }
    return result;
  }

  function normalizeItems(items) {
    if (!Array.isArray(items) || items.length < 1 || items.length > MAX_ITEMS) return null;

    var normalized = [];
    for (var index = 0; index < items.length; index += 1) {
      var item = items[index];
      if (!item || typeof item !== 'object') return null;

      var id = Number(item.id);
      var quantity = Number(item.quantity);
      var properties = safeProperties(item.properties);

      if (!Number.isSafeInteger(id) || id <= 0) return null;
      if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > MAX_QUANTITY) return null;
      if (!properties) return null;

      normalized.push({
        id: id,
        quantity: quantity,
        properties: properties
      });
    }

    return normalized;
  }

  function buildResult(requestId, ok, details) {
    // Fail closed: never default Pergola traffic to BBQ source.
    if (!details || !details.source || !Object.prototype.hasOwnProperty.call(SOURCES, details.source)) {
      return null;
    }
    var result = {
      source: details.source,
      type: RESULT_TYPE,
      requestId: requestId,
      ok: Boolean(ok)
    };

    if (details.message) result.message = String(details.message).slice(0, 180);
    if (details.reason) result.reason = String(details.reason).slice(0, 240);
    if (Number.isFinite(details.status)) result.status = details.status;

    return result;
  }

  function postResult(target, targetOrigin, result) {
    if (!result) return;
    if (!target || typeof target.postMessage !== 'function') return;
    target.postMessage(result, targetOrigin);
  }

  function rememberResult(requestId, result) {
    if (!result) return;
    pruneCompleted();
    completed.set(requestId, { result: result, at: Date.now() });
    while (completed.size > 100) {
      var oldest = completed.keys().next();
      if (oldest.done) break;
      completed.delete(oldest.value);
    }
  }

  function pruneCompleted() {
    var now = Date.now();
    completed.forEach(function (entry, key) {
      if (now - entry.at > COMPLETED_TTL_MS) completed.delete(key);
    });
  }

  function frameStudioUrl(frame) {
    return frame.getAttribute('data-src') || frame.getAttribute('src') || '';
  }

  function isKnownSourceFrame(frame, source) {
    try {
      var path = studioPathname(frameStudioUrl(frame));
      return SOURCES[source] === path;
    } catch (error) {
      return false;
    }
  }

  function cartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function sectionRequest(cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') return {};

    var ids = cart.getSectionsToRender()
      .map(function (section) { return section && section.id; })
      .filter(Boolean);

    if (!ids.length) return {};
    return {
      sections: ids,
      sections_url: window.location.pathname
    };
  }

  function renderCart(cart, payload) {
    if (cart && payload && payload.sections && typeof cart.renderContents === 'function') {
      cart.renderContents(payload);
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function friendlyFailure(payload, status) {
    if (status === 422) return 'One or more selected products are unavailable. Please review the design and try again.';
    if (status === 429) return 'Too many cart requests. Please wait a moment and try again.';
    if (payload && typeof payload.description === 'string' && payload.description.trim()) {
      return payload.description.trim().slice(0, 220);
    }
    return 'Shopify could not add this configuration to the cart.';
  }

  function normalizeContact(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    var email = typeof value.email === 'string' ? value.email.trim() : '';
    var name = typeof value.name === 'string' ? value.name.trim() : '';
    var phone = typeof value.phone === 'string' ? value.phone.trim() : '';
    var postcode = typeof value.postcode === 'string' ? value.postcode.trim() : '';
    var body = typeof value.body === 'string' ? value.body.trim() : '';
    var requestType = typeof value.requestType === 'string' ? value.requestType.trim() : 'Configurator quote';
    if (!email || email.length > 254) return null;
    if (!name || name.length > 120) return null;
    if (!phone || phone.length > 40) return null;
    if (!postcode || postcode.length > 16) return null;
    if (!body || body.length > MAX_CONTACT_BODY) return null;
    return {
      email: email,
      name: name.slice(0, 120),
      phone: phone.slice(0, 40),
      postcode: postcode.slice(0, 16),
      body: body.slice(0, MAX_CONTACT_BODY),
      requestType: requestType.slice(0, 80) || 'Configurator quote'
    };
  }

  function appendHidden(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function buildContactForm(contact) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/contact#contact_form';
    form.acceptCharset = 'UTF-8';
    form.hidden = true;
    form.setAttribute('aria-hidden', 'true');
    appendHidden(form, 'form_type', 'contact');
    appendHidden(form, 'utf8', '\u2713');
    appendHidden(form, 'contact[email]', contact.email);
    appendHidden(form, 'contact[name]', contact.name);
    appendHidden(form, 'contact[phone]', contact.phone);
    appendHidden(form, 'contact[Postcode]', contact.postcode);
    appendHidden(form, 'contact[Request type]', contact.requestType);
    appendHidden(form, 'contact[body]', contact.body);
    return form;
  }

  function protectContactForm(form) {
    var captcha = window.Shopify && window.Shopify.captcha;
    if (!captcha || typeof captcha.protect !== 'function') return Promise.resolve(false);
    return new Promise(function (resolve, reject) {
      var timer = window.setTimeout(function () {
        reject(new Error('Verification did not load. Refresh the page and try again.'));
      }, 15000);
      try {
        captcha.protect(form, function () {
          window.clearTimeout(timer);
          resolve(true);
        });
      } catch (error) {
        window.clearTimeout(timer);
        reject(error);
      }
    });
  }

  /**
   * Shopify contact form, submitted in this window.
   * A fetch() POST is rate-limited, and Shopify will not draw its check inside a frame.
   */
  function submitContact(contact) {
    var run = contactSubmitQueue.then(function () {
      return submitContactOnce(contact);
    });
    contactSubmitQueue = run.then(function () { return undefined; }, function () { return undefined; });
    return run;
  }

  function showQuoteNotice(text) {
    if (document.querySelector('[data-egj-quote-sent]')) return;
    var note = document.createElement('div');
    note.setAttribute('data-egj-quote-sent', 'true');
    note.setAttribute('role', 'status');
    note.textContent = text;
    note.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;z-index:2147483646;background:#111;color:#fff;padding:14px 16px;border-radius:12px;max-width:440px;margin:0 auto;font:16px/1.4 sans-serif;';
    document.body.appendChild(note);
  }

  function showQuoteSentNotice() {
    if (!/[?&]contact_posted=true(?:[&#]|$)/.test(window.location.href)) return;
    var delivered = false;
    try { delivered = sessionStorage.getItem('egj-quote-delivered') === '1'; } catch (error) { delivered = false; }
    if (!delivered) {
      showQuoteNotice('That check finished without the quote. Refresh and send it once more.');
      return;
    }
    try {
      sessionStorage.removeItem('egj-quote-delivered');
      sessionStorage.removeItem('egj-quote-contact');
    } catch (error) { /* ignore */ }
    showQuoteNotice('Quote request sent to Grill King. We will confirm pricing and availability.');
  }

  function persistQuoteForm(form) {
    var alphabet = '0123456789abcdefghijklmnopqrstuvwxyz';
    var key = '';
    for (var i = 0; i < 32; i += 1) key += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
    appendHidden(form, 'form_key', key);
    var skip = { 'h-captcha-response': true, 'g-recaptcha-response': true, 'recaptcha-v3-token': true, password: true };
    var data = {};
    new FormData(form).forEach(function (value, name) {
      if (!skip[name]) data[name] = String(value);
    });
    sessionStorage.setItem(key, JSON.stringify({ __shopify_v: 1, action: form.action, data: data }));
    sessionStorage.setItem('egj-quote-contact', JSON.stringify(data));
    sessionStorage.removeItem('egj-quote-delivered');
  }

  function storedQuoteData() {
    var params = new URLSearchParams(window.location.search);
    var key = params.get('form_key');
    try {
      if (key) {
        var stored = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (stored && stored.data) return stored.data;
      }
    } catch (error) { /* ignore */ }
    try {
      return JSON.parse(sessionStorage.getItem('egj-quote-contact') || 'null');
    } catch (error) {
      return null;
    }
  }

  function attachQuoteToChallenge() {
    if (window.location.pathname !== '/challenge') return;
    var data = storedQuoteData();
    var form = document.querySelector('#captcha_form, form#captcha-form, form[action*="/contact"]');
    if (!data || !form || form.getAttribute('data-egj-quote-attached') === 'true') return;
    Object.keys(data).forEach(function (name) {
      if (!name || name === 'form_key') return;
      var existing = form.elements[name];
      if (existing && typeof existing.value === 'string') {
        if (!existing.value) existing.value = data[name];
        return;
      }
      appendHidden(form, name, data[name]);
    });
    form.setAttribute('data-egj-quote-attached', 'true');
    try { sessionStorage.setItem('egj-quote-delivered', '1'); } catch (error) { /* ignore */ }
    if (!document.querySelector('[data-egj-challenge-note]')) {
      var note = document.createElement('p');
      note.setAttribute('data-egj-challenge-note', 'true');
      note.textContent = 'Finish this check and Grill King receives the quote.';
      note.style.cssText = 'margin:0 0 12px;font:16px/1.4 sans-serif;';
      form.insertBefore(note, form.firstChild);
    }
  }

  function watchChallengeForm() {
    if (window.location.pathname !== '/challenge') return;
    attachQuoteToChallenge();
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      attachQuoteToChallenge();
      if (document.querySelector('[data-egj-quote-attached]') || attempts > 20) window.clearInterval(timer);
    }, 250);
  }

  function contactAccepted(url, html) {
    return /[?&]contact_posted=true(?:[&#]|$)/.test(url || '') || /data-egj-contact-success(?:[\s=>])/.test(html || '');
  }

  function captureContactCaptchaToken(form) {
    var proto = window.HTMLFormElement && window.HTMLFormElement.prototype;
    if (!proto || typeof proto.submit !== 'function') {
      return Promise.reject(new Error('This browser cannot submit the quote form.'));
    }
    var originalSubmit = proto.submit;
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = window.setTimeout(function () {
        finish(new Error('Verification did not complete. Please try again.'));
      }, 30000);

      function restore() {
        if (proto.submit === intercept) proto.submit = originalSubmit;
        window.clearTimeout(timer);
      }

      function finish(error, token) {
        if (settled) return;
        settled = true;
        restore();
        if (error) reject(error);
        else resolve(token || '');
      }

      function intercept() {
        if (this !== form) return originalSubmit.apply(this, arguments);
        var tokenInput = form.querySelector('[name="h-captcha-response"], [name="g-recaptcha-response"], [name="recaptcha-v3-token"]');
        finish(null, tokenInput && tokenInput.value ? tokenInput.value : '');
      }

      proto.submit = intercept;
      protectContactForm(form).then(function (ready) {
        if (!ready) {
          finish(null, '');
          return;
        }
        try {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        } catch (error) {
          finish(error);
        }
      }).catch(function (error) {
        finish(error);
      });
    });
  }

  function postContactBody(url, params) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'text/html'
      },
      credentials: 'same-origin',
      redirect: 'follow',
      body: params.toString()
    });
  }

  function quoteSentMessage(contact, copied) {
    if (copied) return 'Quote accepted for Grill King. We will reply to ' + contact.email + '.';
    return 'Quote sent to Grill King. We will reply to ' + contact.email + '.';
  }

  function sendCustomerCopy(contact) {
    return fetch('https://formsubmit.co/ajax/' + encodeURIComponent(QUOTE_INBOX), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        _subject: (contact.requestType + ' — ' + contact.name).slice(0, 180),
        _template: 'table',
        _captcha: 'false',
        _replyto: contact.email,
        _cc: QUOTE_INBOX_CC,
        name: contact.name,
        email: contact.email,
        phone: contact.phone,
        postcode: contact.postcode,
        message: contact.body
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Quote provider rejected the request.');
      return response.json();
    }).then(function (payload) {
      return !!(payload && String(payload.success) === 'true');
    }).catch(function () {
      return false;
    });
  }

  function confirmOnThisPage(html, pageUrl, contact) {
    var sitekey = (html.match(/sitekey:\s*"([^"]+)"/) || html.match(/data-sitekey="([^"]+)"/) || [])[1];
    if (!sitekey || !window.hcaptcha || typeof window.hcaptcha.render !== 'function') {
      return Promise.reject(new Error('Shopify did not accept this quote. Please try again.'));
    }
    return new Promise(function (resolve, reject) {
      var host = document.createElement('div');
      host.setAttribute('role', 'dialog');
      host.setAttribute('aria-label', 'Confirm to send your quote');
      host.style.cssText = 'position:fixed;inset:0;z-index:2147483646;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;padding:16px;';
      var card = document.createElement('div');
      card.style.cssText = 'background:#fff;color:#111;padding:20px;border-radius:12px;width:min(360px,100%);';
      var label = document.createElement('p');
      label.textContent = 'Tick the box to send this quote. You stay on this page.';
      label.style.margin = '0 0 12px';
      var widget = document.createElement('div');
      var cancel = document.createElement('button');
      cancel.type = 'button';
      cancel.textContent = 'Cancel';
      cancel.style.marginTop = '12px';
      card.appendChild(label);
      card.appendChild(widget);
      card.appendChild(cancel);
      host.appendChild(card);
      document.body.appendChild(host);
      var settled = false;
      var timer = 0;
      function close(error, message) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        if (host.parentNode) host.parentNode.removeChild(host);
        if (error) reject(error);
        else resolve(message);
      }
      timer = window.setTimeout(function () {
        close(new Error('Confirmation was not finished. Please try again.'));
      }, 120000);
      cancel.addEventListener('click', function () {
        close(new Error('Quote was not sent.'));
      });

      try {
        window.hcaptcha.render(widget, {
          sitekey: sitekey,
          callback: function (token) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var sourceForm = parsed.querySelector('#captcha_form');
            var authenticity = sourceForm && sourceForm.querySelector('[name="authenticity_token"]');
            var challengeUrl = new URL(pageUrl, window.location.href);
            var formKey = challengeUrl.searchParams.get('form_key');
            var stored = null;
            try { stored = JSON.parse(sessionStorage.getItem(formKey) || 'null'); } catch (error) { stored = null; }
            var data = stored && stored.data ? stored.data : {
              'form_type': 'contact',
              'utf8': '\u2713',
              'contact[email]': contact.email,
              'contact[name]': contact.name,
              'contact[phone]': contact.phone,
              'contact[Postcode]': contact.postcode,
              'contact[Request type]': contact.requestType,
              'contact[body]': contact.body
            };
            if (!data['contact[body]'] || !data['contact[email]']) {
              close(new Error('Shopify did not accept this quote. Please try again.'));
              return;
            }
            var action = stored && stored.action ? String(stored.action).split('#')[0] : '/contact';
            var returnPath = challengeUrl.searchParams.get('return_path') || window.location.pathname;
            var frameName = 'egj-quote-result';
            var iframe = document.createElement('iframe');
            iframe.name = frameName;
            iframe.setAttribute('aria-hidden', 'true');
            iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;';
            var form = document.createElement('form');
            form.method = 'post';
            form.action = action;
            form.target = frameName;
            form.acceptCharset = 'UTF-8';
            form.setAttribute('data-nocaptcha', 'true');
            function addField(name, value) {
              var input = document.createElement('input');
              input.type = 'hidden';
              input.name = name;
              input.value = value == null ? '' : String(value);
              form.appendChild(input);
            }
            if (authenticity && authenticity.value) addField('authenticity_token', authenticity.value);
            addField('skp', 'hi');
            addField('h-captcha-response', token);
            Object.keys(data).forEach(function (name) { addField(name, data[name]); });
            addField('return_path', returnPath);
            document.body.appendChild(iframe);
            document.body.appendChild(form);
            iframe.addEventListener('load', function () {
              try {
                if (contactAccepted(iframe.contentWindow.location.href, '')) {
                  window.clearInterval(poll);
                  iframe.remove();
                  form.remove();
                  close(null, quoteSentMessage(contact, false));
                }
              } catch (error) { /* Shopify hides the result frame. The poll below decides. */ }
            });
            HTMLFormElement.prototype.submit.call(form);
            var tries = 0;
            var poll = window.setInterval(function () {
              tries += 1;
              fetch(challengeUrl.href, { credentials: 'same-origin', redirect: 'follow' }).then(function (response) {
                return response.text().then(function (body) {
                  return { response: response, body: body };
                });
              }).then(function (result) {
                if (!contactAccepted(result.response.url, result.body)) {
                  if (tries < 8) return;
                  window.clearInterval(poll);
                  iframe.remove();
                  form.remove();
                  close(new Error('Shopify did not accept this quote. Please try again.'));
                  return;
                }
                window.clearInterval(poll);
                iframe.remove();
                form.remove();
                close(null, quoteSentMessage(contact, false));
              }).catch(function () {
                if (tries < 8) return;
                window.clearInterval(poll);
                iframe.remove();
                form.remove();
                close(new Error('Could not reach the Shopify contact form.'));
              });
            }, 800);
          }
        });
      } catch (error) {
        close(error instanceof Error ? error : new Error('Confirmation could not be shown.'));
      }
    });
  }

  async function submitContactOnce(contact) {
    var form = buildContactForm(contact);
    document.body.appendChild(form);
    var copyPromise = sendCustomerCopy(contact);
    try {
      var token = await captureContactCaptchaToken(form);
      var params = new URLSearchParams(new FormData(form));
      if (token && !params.get('h-captcha-response') && !params.get('g-recaptcha-response') && !params.get('recaptcha-v3-token')) {
        params.set('h-captcha-response', token);
      }
      var response = await postContactBody('/contact', params);
      if (response.status === 429) {
        throw new Error('Shopify is busy. Wait a few minutes and send the quote once.');
      }
      if (!response.ok && !/\/challenge(?:\?|$)/.test(response.url)) {
        throw new Error('Shopify contact form failed (' + response.status + ').');
      }
      var posted = contactAccepted(response.url, '');
      var html = posted ? '' : await response.text();
      var copied = await copyPromise;
      if (posted || contactAccepted(response.url, html)) {
        return quoteSentMessage(contact, copied);
      }
      if (/\/challenge(?:\?|$)/.test(response.url) || /captcha_form|data-sitekey|sitekey/.test(html)) {
        var confirmed = await confirmOnThisPage(html, response.url, contact);
        if (copied) return 'Quote accepted for Grill King. We will reply to ' + contact.email + '.';
        return confirmed;
      }
      throw new Error('Shopify did not accept this quote. Please try again.');
    } finally {
      if (form.parentNode) form.parentNode.removeChild(form);
    }
  }

  async function addItems(items) {
    var cart = cartComponent();
    if (cart && typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(document.activeElement);
    }

    var body = Object.assign({ items: items }, sectionRequest(cart));
    var endpoint = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';

    var response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });

    var payload = null;
    try {
      payload = await response.json();
    } catch (error) {
      payload = null;
    }

    if (!response.ok) {
      var failure = new Error(friendlyFailure(payload, response.status));
      failure.status = response.status;
      throw failure;
    }

    renderCart(cart, payload);

    var quantity = items.reduce(function (total, item) {
      return total + item.quantity;
    }, 0);

    return 'Added ' + quantity + ' item' + (quantity === 1 ? '' : 's') + ' to cart';
  }

  document.addEventListener('gk:delivery-postcode', function (event) {
    var postcode = event.detail && typeof event.detail.postcode === 'string' ? event.detail.postcode : '';
    if (!/^\d{4}$/.test(postcode)) return;
    try { sessionStorage.setItem('gk-delivery-postcode', postcode); } catch (error) { /* ignore */ }
    postStudioToFrames('studio:delivery-check', { postcode: postcode });
  });

  showQuoteSentNotice();
  watchChallengeForm();
  announceReady();
  window.setTimeout(announceReady, 300);
  window.setTimeout(announceReady, 1200);
  window.setTimeout(announceReady, 3000);

  window.addEventListener('message', async function (event) {
    if (!isAllowedOrigin(event.origin)) return;
    if (!isKnownStudioFrame(event.source, event.origin)) return;

    var data = event.data;
    if (!data || typeof data !== 'object') return;
    if (!Object.prototype.hasOwnProperty.call(SOURCES, data.source)) return;

    if (data.type === PROBE_TYPE && data.version === 1) {
      postResult(event.source, event.origin, {
        source: data.source,
        type: READY_TYPE,
        version: 1
      });
      return;
    }

    if (data.type === CONTACT_REQUEST_TYPE) {
      if (typeof data.requestId !== 'string' || !data.requestId || data.requestId.length > 160) return;

      pruneCompleted();
      if (completed.has(data.requestId)) {
        postResult(event.source, event.origin, completed.get(data.requestId).result);
        return;
      }
      if (pending.has(data.requestId)) return;

      var contactFrame = null;
      var contactFrames = document.querySelectorAll('iframe[data-egj-iframe]');
      for (var cfi = 0; cfi < contactFrames.length; cfi += 1) {
        if (contactFrames[cfi].contentWindow === event.source) {
          contactFrame = contactFrames[cfi];
          break;
        }
      }
      if (!contactFrame || !isKnownSourceFrame(contactFrame, data.source)) return;

      var contact = normalizeContact(data.contact);
      if (!contact) {
        var invalidContact = buildResult(data.requestId, false, {
          source: data.source,
          reason: 'Invalid quote contact payload from the configurator.'
        });
        invalidContact.type = CONTACT_RESULT_TYPE;
        rememberResult(data.requestId, invalidContact);
        postResult(event.source, event.origin, invalidContact);
        return;
      }

      pending.set(data.requestId, Date.now());
      var contactTimer = window.setTimeout(function () {
        if (!pending.has(data.requestId)) return;
        pending.delete(data.requestId);
        var timedOut = buildResult(data.requestId, false, {
          source: data.source,
          reason: 'The quote contact request timed out. Please try again.'
        });
        timedOut.type = CONTACT_RESULT_TYPE;
        postResult(event.source, event.origin, timedOut);
      }, CONTACT_PENDING_TIMEOUT_MS);

      try {
        var contactMessage = await submitContact(contact);
        var contactOk = buildResult(data.requestId, true, {
          source: data.source,
          message: contactMessage
        });
        contactOk.type = CONTACT_RESULT_TYPE;
        rememberResult(data.requestId, contactOk);
        postResult(event.source, event.origin, contactOk);
      } catch (contactError) {
        var contactFail = buildResult(data.requestId, false, {
          source: data.source,
          status: contactError && Number.isFinite(contactError.status) ? contactError.status : undefined,
          reason: contactError && contactError.message
            ? contactError.message
            : 'Shopify contact request failed.'
        });
        contactFail.type = CONTACT_RESULT_TYPE;
        rememberResult(data.requestId, contactFail);
        postResult(event.source, event.origin, contactFail);
      } finally {
        window.clearTimeout(contactTimer);
        pending.delete(data.requestId);
      }
      return;
    }

    if (typeof data.type === 'string' && data.type.indexOf('studio:') === 0) {
      if (data.version !== 1) return;
      var studioPayload = sanitizeStudioPayload(data.payload);
      if (data.type === 'studio:delivery-check' && typeof studioPayload.postcode === 'string') {
        try { sessionStorage.setItem('gk-delivery-postcode', studioPayload.postcode); } catch (error) { /* ignore */ }
        var postcodeInputs = document.querySelectorAll('.delivery_estimate input[name="postcode"]');
        for (var inputIndex = 0; inputIndex < postcodeInputs.length; inputIndex += 1) {
          if (!postcodeInputs[inputIndex].value) postcodeInputs[inputIndex].value = studioPayload.postcode;
        }
      }
      document.dispatchEvent(new CustomEvent('gk:studio', {
        detail: {
          source: data.source,
          type: data.type,
          requestId: typeof data.requestId === 'string' ? data.requestId.slice(0, 160) : '',
          timestamp: typeof data.timestamp === 'number' ? data.timestamp : Date.now(),
          payload: studioPayload
        }
      }));
      return;
    }

    if (data.type !== REQUEST_TYPE) return;
    if (typeof data.requestId !== 'string' || !data.requestId || data.requestId.length > 160) return;

    pruneCompleted();
    if (completed.has(data.requestId)) {
      postResult(event.source, event.origin, completed.get(data.requestId).result);
      return;
    }
    if (pending.has(data.requestId)) return;

    var requestingFrame = null;
    var frames = document.querySelectorAll('iframe[data-egj-iframe]');
    for (var frameIndex = 0; frameIndex < frames.length; frameIndex += 1) {
      if (frames[frameIndex].contentWindow === event.source) {
        requestingFrame = frames[frameIndex];
        break;
      }
    }
    if (!requestingFrame || !isKnownSourceFrame(requestingFrame, data.source)) return;

    var items = normalizeItems(data.items);
    if (!items) {
      var invalidResult = buildResult(data.requestId, false, {
        source: data.source,
        reason: 'Invalid cart payload from the configurator.'
      });
      rememberResult(data.requestId, invalidResult);
      postResult(event.source, event.origin, invalidResult);
      return;
    }

    pending.set(data.requestId, Date.now());
    // A hung fetch must never block a requestId retry forever.
    // Preserve `data.source` so pergola (grillking-pergola) clients accept the timeout.
    var pendingTimer = window.setTimeout(function () {
      if (!pending.has(data.requestId)) return;
      pending.delete(data.requestId);
      postResult(event.source, event.origin, buildResult(data.requestId, false, {
        source: data.source,
        reason: 'The cart request timed out. Please try again.'
      }));
    }, PENDING_TIMEOUT_MS);
    try {
      var message = await addItems(items);
      var successResult = buildResult(data.requestId, true, { source: data.source, message: message });
      rememberResult(data.requestId, successResult);
      postResult(event.source, event.origin, successResult);
    } catch (error) {
      var errorResult = buildResult(data.requestId, false, {
        source: data.source,
        status: error && Number.isFinite(error.status) ? error.status : undefined,
        reason: error && error.message ? error.message : 'Shopify cart request failed.'
      });
      rememberResult(data.requestId, errorResult);
      postResult(event.source, event.origin, errorResult);
    } finally {
      window.clearTimeout(pendingTimer);
      pending.delete(data.requestId);
    }
  });
})();
